export default __webpack_public_path__ + "static/media/05_DAIF_UseCase_04_05_Loop.f045e8ee.mp4";